import { FaBed } from 'react-icons/fa';

const RoomAssignment = ({ currentStep, setCurrentStep, totalSteps }) => {
  // Get data from localStorage
  const bookingDetails = JSON.parse(localStorage.getItem('bookingDetails'));
  const assignedRooms = JSON.parse(localStorage.getItem('assignedRooms'));

  // Assuming we're working with the first assigned room
  const assignedRoom = assignedRooms?.[0] || {};
  const primaryBooking = bookingDetails?.primaryBooking || {};

  // Function to format date as "DD-MM-YYYY"
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleDone = () => {
    window.location.href = '/reservation/options/booking/welcome';
  };

  return (
    <div className="">
      <h2 className="text-xl font-bold mb-1 text-gray-900">Check-In Successful</h2>
      <p className="text-gray-600 text-sm mb-4">Your {assignedRoom.room_type} is ready</p>

      <div className="bg-white shadow-xl rounded-lg overflow-hidden border border-gray-200">
        {/* Room Details - Compact Horizontal Layout */}
        <div className="flex flex-col md:flex-row">
          {/* Room Image */}
          <div className="md:w-1/3 h-76 bg-gray-100 overflow-hidden">
            {assignedRoom.room_images?.length > 0 || assignedRoom.roomtype_images?.length > 0 ? (
              <img
                src={assignedRoom.room_images?.[0] || assignedRoom.roomtype_images?.[0]}
                alt={assignedRoom.room_type}
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-gray-400">
                <FaBed className="text-4xl" />
              </div>
            )}
          </div>

          {/* Room Info */}
          <div className="md:w-2/3 p-4">
            <div className="flex justify-between items-start mb-2">
              <div>
                <h3 className="text-lg font-bold text-gray-900">
                  Room {assignedRoom.room_number} ({assignedRoom.room_type})
                </h3>
              </div>
            </div>

            <p className="text-sm text-gray-700 mb-3">{assignedRoom.room_description}</p>

            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <p className="text-xs text-gray-500">Check-in Date</p>
                <p className="font-medium">{formatDate(primaryBooking.checkin_date)}</p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Check-out Date</p>
                <p className="font-medium">{formatDate(primaryBooking.checkout_date)}</p>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <p className="text-xs text-gray-500">Number of Guests</p>
                <p className="font-medium">
                  {primaryBooking.number_of_guests} Guest
                  {primaryBooking.number_of_guests !== 1 ? 's' : ''}
                </p>
              </div>
              <div>
                <p className="text-xs text-gray-500">Number of Nights</p>
                <p className="font-medium">
                  {primaryBooking.length_of_stay} Night
                  {primaryBooking.length_of_stay !== 1 ? 's' : ''}
                </p>
              </div>
            </div>

            {/* Amenities & Services */}
            <div className="space-y-3">
              {assignedRoom.amenities?.length > 0 && (
                <div>
                  <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1">
                    Amenities
                  </h4>
                  <div className="flex flex-wrap gap-1">
                    {assignedRoom.amenities.map((amenity, index) => (
                      <span
                        key={index}
                        className="px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded-full"
                      >
                        {amenity}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {assignedRoom.room_services?.length > 0 && (
                <div>
                  <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1">
                    Services
                  </h4>
                  <div className="flex flex-wrap gap-1">
                    {assignedRoom.room_services.map((service, index) => (
                      <span
                        key={index}
                        className="px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded-full"
                      >
                        {service}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <p className="text-md text-gray-600 mb-4 text-center font-bold text-lg mt-4">
        <span className="font-bold text-lg text-black"></span> Your {assignedRoom.room_type} is
        ready for Checkin, Please collect your keys at the front desk
      </p>

      <div className="flex justify-center">
        <button
          onClick={handleDone}
          className="w-3/4 sm:w-1/2 md:w-1/3 lg:w-1/4 bg-black hover:bg-gray-800 text-white py-3 rounded-md font-medium transition shadow-md hover:shadow-lg"
        >
          Complete Check-In
        </button>
      </div>
    </div>
  );
};

export default RoomAssignment;

// import { FaBed } from "react-icons/fa";

// const RoomAssignment = ({ currentStep, setCurrentStep, totalSteps }) => {
//   // Get data from localStorage
//   const bookingDetails = JSON.parse(localStorage.getItem("bookingDetails"));
//   const assignedRooms = JSON.parse(localStorage.getItem("assignedRooms"));

//   // Assuming we're working with the first assigned room
//   const assignedRoom = assignedRooms?.[0] || {};
//   const primaryBooking = bookingDetails?.primaryBooking || {};

//   // Function to format date as "DD-MM-YYYY"
//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     const date = new Date(dateString);
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
//     const year = date.getFullYear();
//     return `${day}-${month}-${year}`;
//   };

//   const handleDone = () => {
//     window.location.href = "/reservation/options/booking/welcome";
//   };

//   return (
//     <div className="">
//       <h2 className="text-xl font-bold mb-1 text-gray-900">
//         Check-In Successful
//       </h2>
//       <p className="text-gray-600 text-sm mb-4">
//         Your {assignedRoom.room_type} is ready
//       </p>

//       <div className="bg-white shadow-xl rounded-lg overflow-hidden border border-gray-200">
//         {/* Room Details - Compact Horizontal Layout */}
//         <div className="flex flex-col md:flex-row">
//           {/* Room Image */}
//           <div className="md:w-1/3 h-76 bg-gray-100 overflow-hidden">
//             {assignedRoom.room_images?.length > 0 ||
//             assignedRoom.roomtype_images?.length > 0 ? (
//               <img
//                 src={
//                   assignedRoom.room_images?.[0] ||
//                   assignedRoom.roomtype_images?.[0]
//                 }
//                 alt={assignedRoom.room_type}
//                 className="w-full h-full object-cover"
//               />
//             ) : (
//               <div className="w-full h-full flex items-center justify-center text-gray-400">
//                 <FaBed className="text-4xl" />
//               </div>
//             )}
//           </div>

//           {/* Room Info */}
//           <div className="md:w-2/3 p-4">
//             <div className="flex justify-between items-start mb-2">
//               <div>
//                 <h3 className="text-lg font-bold text-gray-900">
//                   Room {assignedRoom.room_number} ({assignedRoom.room_type})
//                 </h3>
//               </div>
//             </div>

//             <p className="text-sm text-gray-700 mb-3">
//               {assignedRoom.room_description}
//             </p>

//             <div className="grid grid-cols-2 gap-4 mb-3">
//               <div>
//                 <p className="text-xs text-gray-500">Check-in Date</p>
//                 <p className="font-medium">
//                   {formatDate(primaryBooking.checkin_date)}
//                 </p>
//               </div>
//               <div>
//                 <p className="text-xs text-gray-500">Check-out Date</p>
//                 <p className="font-medium">
//                   {formatDate(primaryBooking.checkout_date)}
//                 </p>
//               </div>
//             </div>

//             <div className="mb-4">
//               <p className="text-xs text-gray-500">Number of Guests</p>
//               <p className="font-medium">
//                 {primaryBooking.number_of_guests} guest(s)
//               </p>
//             </div>

//             {/* Amenities & Services */}
//             <div className="space-y-3">
//               {assignedRoom.amenities?.length > 0 && (
//                 <div>
//                   <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1">
//                     Amenities
//                   </h4>
//                   <div className="flex flex-wrap gap-1">
//                     {assignedRoom.amenities.map((amenity, index) => (
//                       <span
//                         key={index}
//                         className="px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded-full"
//                       >
//                         {amenity}
//                       </span>
//                     ))}
//                   </div>
//                 </div>
//               )}

//               {assignedRoom.room_services?.length > 0 && (
//                 <div>
//                   <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-1">
//                     Services
//                   </h4>
//                   <div className="flex flex-wrap gap-1">
//                     {assignedRoom.room_services.map((service, index) => (
//                       <span
//                         key={index}
//                         className="px-2 py-1 bg-gray-100 text-gray-800 text-xs rounded-full"
//                       >
//                         {service}
//                       </span>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>

//       <p className="text-md text-gray-600 mb-4 text-center font-bold text-lg mt-4">
//         <span className="font-bold text-lg text-black"></span> Please collect
//         your keys at the front desk
//       </p>

//       <div className="flex justify-center">
//         <button
//           onClick={handleDone}
//           className="w-3/4 sm:w-1/2 md:w-1/3 lg:w-1/4 bg-red-500 hover:bg-gray-800 text-white py-3 rounded-md font-medium transition shadow-md hover:shadow-lg"
//         >
//           Complete Check-In
//         </button>
//       </div>
//     </div>
//   );
// };

// export default RoomAssignment;
